const Template = `<nav>
<router-link to="Page1_tubes">{{$t('nav.tubes')}}</router-link>
<router-link to="OneWireData">{{$t('nav.oneWireData')}}</router-link>
<router-link to="Page2_modems">{{$t('nav.modems')}}</router-link>
<router-link to="Page3_users">{{$t('nav.users')}}</router-link>
<router-link to="Page4_addmodem">{{$t('nav.addModem')}}</router-link>
<router-link to="Page5_notifications">{{$t('nav.messages')}}</router-link>
<router-link to="Page6_phones">{{$t('nav.telList')}}</router-link>
<router-link to="/login" class="logout">{{$t('nav.signOut')}}</router-link>

<b-dropdown id="lang" dropleft class="" size="sm" variant="link" no-caret>
    <template v-slot:button-content>
       <vf-icon :country="$t('general.langType')"/> {{$t('general.lang')}}
    </template>
    <b-dropdown-item href="#" @click="setLocale('ru')"><vf-icon country="ru"/> {{this.$i18n.messages.ru.general.lang}}</b-dropdown-item>
    <b-dropdown-item href="#" @click="setLocale('gb')"><vf-icon country="gb"/> {{this.$i18n.messages.gb.general.lang}}</b-dropdown-item>
</b-dropdown>


</nav>`

export { Template }


// WEBPACK FOOTER //
// ./src/app/js/components/menu/template.js